"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

var _checkbox_states = _interopRequireDefault(require("./utils/checkbox_states"));

require("../css/checkbox.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CHECKED_STATES_TO_BOOL = {
  unchecked: false,
  false: false,
  indeterminated: true,
  checked: true,
  true: true
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOnChange", function (event) {
      if (_this.props.disabled) return;

      _this.setState(function (state) {
        return {
          checked: !state.checked
        };
      });

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOnKeyDown", function (event) {
      if (_this.props.disabled) return;

      switch (event.keyCode) {
        case 32:
          // SPACE
          _this.setState(function (state) {
            return {
              checked: !state.checked
            };
          });

          if (_this.props.onChange) {
            _this.props.onChange(event);
          }

          break;

        default:
          break;
      }
    });

    _this.state = {
      checked: props.checked
    };
    return _this;
  }

  _createClass(Checkbox, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          id = _this$props.id,
          label = _this$props.label,
          name = _this$props.name,
          color = _this$props.color,
          other = _objectWithoutProperties(_this$props, ["className", "disabled", "id", "label", "name", "color"]);

      var labelClasses = {
        'vn-checkbox__label': true,
        'vn-checkbox__label--disabled': disabled
      };

      if (className) {
        labelClasses[className] = true;
      }

      var checkedState = this.state.checked;
      var checkIcon;

      if (_checkbox_states.default[checkedState] === _checkbox_states.default.checked) {
        checkIcon = 'checkmark';
      } else if (_checkbox_states.default[checkedState] === _checkbox_states.default.indeterminated) {
        checkIcon = 'polygon';
      }

      var spanClasses = {
        'vn-checkbox__span': true,
        'vn-checkbox__span--checked': CHECKED_STATES_TO_BOOL[this.state.checked],
        'vn-checkbox__span--disabled': disabled
      };
      var checkboxTemplate;

      if (this.props.icon === undefined) {
        checkboxTemplate = _react.default.createElement("span", {
          className: (0, _classnames.default)(spanClasses)
        }, _react.default.createElement(_icon.default, {
          name: "checkmark",
          size: 24,
          display: checkIcon === 'checkmark' ? 'block' : 'none',
          className: "vn-checkbox__check-icon"
        }), _react.default.createElement(_icon.default, {
          name: "polygon",
          size: 12,
          display: checkIcon === 'polygon' ? 'block' : 'none',
          className: "vn-checkbox__icon"
        }));
      } else {
        var _iconClasses;

        var iconClasses = (_iconClasses = {
          'vn-checkbox__icon': true
        }, _defineProperty(_iconClasses, "vn-color--".concat(color), disabled !== true && color !== undefined), _defineProperty(_iconClasses, 'vn-checkbox__icon--primary-color', disabled !== true && color === undefined), _iconClasses);
        checkboxTemplate = _react.default.createElement("div", null, _react.default.createElement(_icon.default, {
          className: (0, _classnames.default)(iconClasses),
          name: "".concat(this.props.icon, "-filled"),
          size: 24,
          display: this.state.checked ? 'block' : 'none',
          onKeyDown: this.handleOnKeyDown,
          disabled: disabled
        }), _react.default.createElement(_icon.default, {
          className: (0, _classnames.default)(iconClasses),
          name: "".concat(this.props.icon),
          size: 24,
          display: !this.state.checked ? 'block' : 'none',
          onKeyDown: this.handleOnKeyDown,
          disabled: disabled
        }));
      }

      return _react.default.createElement("label", {
        className: (0, _classnames.default)(labelClasses),
        htmlFor: id
      }, _react.default.createElement("input", _extends({}, other, {
        checked: this.state.checked,
        className: "vn-checkbox",
        disabled: disabled,
        id: id,
        name: name,
        onChange: this.handleOnChange,
        type: "checkbox"
      })), checkboxTemplate, label ? _react.default.createElement("span", {
        className: "vn-checkbox__span-text"
      }, label) : '');
    }
  }]);

  return Checkbox;
}(_react.default.Component);

Checkbox.defaultProps = {
  className: undefined,
  checked: false,
  disabled: false,
  id: undefined,
  label: '',
  icon: undefined,
  onChange: function onChange() {},
  color: undefined
};
Checkbox.propTypes = {
  className: _propTypes.default.string,
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  label: _propTypes.default.node,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  icon: _propTypes.default.string,
  color: _propTypes.default.string
};
Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
exports.default = _default;